module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits XL tyg orinocco grey miljö 2023 stående.f1a7e9f6.jpg";